// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1__d99a8ae9461715976c92","cls2":"ImpactHubModal-cls2___c3b066387c29ed2ea34 ImpactHubModal-cls1__d99a8ae9461715976c92"};